
import { TranslationsType, LanguageEntry } from '@/types/language';
import englishTranslations from './english';
import hebrewTranslations from './hebrew';
import arabicTranslations from './arabic';
import frenchTranslations from './french';
import spanishTranslations from './spanish';

// Combine all translations
export const translations: TranslationsType = {
  en: englishTranslations,
  he: hebrewTranslations,
  ar: arabicTranslations,
  fr: frenchTranslations,
  es: spanishTranslations
};

// Define available languages with their display names
export const availableLanguages: LanguageEntry[] = [
  { code: 'en', name: 'English', nativeName: 'English', flagIcon: 'us' },
  { code: 'he', name: 'Hebrew', nativeName: 'עברית', flagIcon: 'il' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', flagIcon: 'sa' },
  { code: 'fr', name: 'French', nativeName: 'Français', flagIcon: 'fr' },
  { code: 'es', name: 'Spanish', nativeName: 'Español', flagIcon: 'es' }
];
